// shared/utils/masks.ts

/* ======================
   CPF / CNPJ
====================== */

export function maskCpfCnpj(value: string) {
  const v = value.replace(/\D/g, "");

  if (v.length <= 11) {
    return v
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
      .slice(0, 14);
  }

  return v
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .slice(0, 18);
}

/* ======================
   TELEFONE
====================== */

export function maskTelefone(value: string) {
  const v = value.replace(/\D/g, "");

  if (v.length <= 10) {
    return v
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .slice(0, 14);
  }

  return v
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d)/, "$1-$2")
    .slice(0, 15);
}

/* ======================
   CEP
====================== */

export function maskCep(value: string) {
  return value
    .replace(/\D/g, "")
    .replace(/^(\d{5})(\d)/, "$1-$2")
    .slice(0, 9);
}

/* ======================
   AGÊNCIA BANCÁRIA
====================== */

export function maskAgencia(value: string) {
  const v = value
    .replace(/\D/g, "")
    .slice(0, 5);

  if (v.length <= 4) {
    return v;
  }

  return `${v.slice(0, 4)}-${v.slice(4)}`;
}

/* ======================
   CONTA BANCÁRIA
====================== */

export function maskConta(value: string) {
  const v = value
    .replace(/[^0-9Xx]/g, "")
    .toUpperCase()
    .slice(0, 12);

  if (v.length <= 1) {
    return v;
  }

  return `${v.slice(0, -1)}-${v.slice(-1)}`;
}

/* ======================
   DESCONTO
====================== */

export function maskDesconto(
  valor: string,
  tipo?: "percentual" | "valor"
) {
  const clean = valor.replace(/\D/g, "");

  if (!clean) return "";

  if (tipo === "percentual") {
    const numero = Math.min(
      Number(clean),
      100
    );

    return numero + "%";
  }

  const numero = (
    Number(clean) / 100
  ).toFixed(2);

  return (
    "R$ " +
    numero
      .replace(".", ",")
      .replace(
        /\B(?=(\d{3})+(?!\d))/g,
        "."
      )
  );
}

/* ======================
   CARTÃO
====================== */

export function maskCartao(value: string) {
  return value
    .replace(/\D/g, "")
    .slice(0, 16)
    .replace(
      /(\d{4})(?=\d)/g,
      "$1 "
    );
}

/* ======================
   NOME TITULAR
====================== */

export function maskNomeCartao(value: string) {
  return value
    .replace(/[0-9]/g, "")
    .replace(/\s+/g, " ")
    .trimStart();
}

/* ======================
   CVV
====================== */

export function maskCvv(value: string) {
  return value
    .replace(/\D/g, "")
    .slice(0, 4);
}

/* ======================
   VALIDADE MM/AA
====================== */

export function maskValidade(value: string) {
  const v = value
    .replace(/\D/g, "")
    .slice(0, 4);

  if (v.length <= 2) {
    return v;
  }

  return `${v.slice(0, 2)}/${v.slice(2)}`;
}

